export function packagesEndpoint(category) {
    if (!category)
        return '/api/packages'

    return `/api/packages?category=${encodeURIComponent(category)}`
}

export function visiblePackages(packages, maxItems) {
    const limit = Number.parseInt(maxItems, 10)

    if (!Number.isInteger(limit) || limit < 1)
        return packages

    return packages.slice(0, limit)
}

export function categoryPath(category) {
    return category ? `/packages/${category}` : ''
}

export function isCurrentCategoryPage(path, category) {
    return path.replace(/\/$/, '') === categoryPath(category)
}
